module.exports = __webpack_public_path__ + "static/media/themplane.0f39ccd4.webp";